import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import {
  HlmSelect,
  HlmSelectContent,
  HlmSelectItem,
  HlmSelectPortal,
  HlmSelectTrigger,
  HlmSelectValue,
} from '@spartan-ng/helm/select';

interface SelectOption {
  value: unknown;
  label: string;
}

/**
 * Field type `select` próprio (substitui o do @ngx-formly/primeng).
 * props.options no formato { value, label } (SelectOptionDto), como o
 * metadata-to-formly.mapper produz.
 */
@Component({
  selector: 'evolve-formly-select',
  imports: [
    ReactiveFormsModule,
    FormlyModule,
    HlmSelect,
    HlmSelectContent,
    HlmSelectItem,
    HlmSelectPortal,
    HlmSelectTrigger,
    HlmSelectValue,
  ],
  template: `
    <hlm-select
      class="w-full"
      [itemToString]="optionLabel"
      [isSingleValuePresent]="isValuePresent"
      [formControl]="formControl"
      [formlyAttributes]="field"
    >
      <hlm-select-trigger class="w-full">
        <hlm-select-value [placeholder]="props.placeholder ?? ''" />
      </hlm-select-trigger>
      <hlm-select-content *hlmSelectPortal>
        @for (opt of selectOptions; track opt.value) {
          <hlm-select-item [value]="opt.value">{{ opt.label }}</hlm-select-item>
        }
      </hlm-select-content>
    </hlm-select>
  `,
})
export class SelectFieldComponent extends FieldType<FieldTypeConfig> {
  get selectOptions(): SelectOption[] {
    return (this.props.options as SelectOption[]) ?? [];
  }

  /** Mapeia o value selecionado de volta para o label no trigger. */
  optionLabel = (value: unknown): string =>
    this.selectOptions.find((o) => o.value === value)?.label ??
    String(value ?? '');

  /**
   * @spartan-ng/brain 1.1.2 passou a tratar string vazia como "sem valor"
   * por padrao (isSingleValuePresent). As opcoes deste select vem do
   * backend (SelectOptionDto) e podem ter value: '', entao aqui so
   * undefined/null contam como ausencia — evita cair no placeholder
   * quando a opcao selecionada tem value ''.
   */
  isValuePresent = (value: unknown): boolean =>
    value !== undefined && value !== null;
}
